<div class="p-6 max-w-[1800px] mx-auto">
  <app-load-general [load]="isActionLoading()" />

  <div class="flex items-center gap-2 mb-6"> <a routerLink="/tickets"
      class="flex items-center gap-2 text-xl font-normal hover:opacity-80 cursor-pointer no-underline"
      style="color: var(--color-primary);">
      {{ 'tickets.title' | translate }}
      <mat-icon class="text-xl w-5 h-5" style="color: var(--color-text-muted);">chevron_right</mat-icon>
    </a>
    <span class="text-xl font-normal" style="color: var(--color-primary);">{{ 'tickets.detail.title' | translate
      }}</span>
    <mat-icon class="text-xl w-5 h-5" style="color: var(--color-text-muted);">chevron_right</mat-icon>
    <span class="text-xl font-semibold" style="color: var(--color-primary);">{{ currentOdt() }}</span>
  </div>

  <div class="w-full mb-6">
    @if (ticket()) {
    <app-card class="ticket-detail-card" [title]="ticket()?.solicitante || ''" [status]="approvalStatus()"
      [statusConfig]="statusConfig" [accentByStatus]="accentByStatus" [items]="cardItems()">

      <div card-footer class="flex flex-col sm:flex-row justify-end gap-3">
        <app-button type="danger" [text]="'common.actions.reject' | translate" icon="close" size="md"
          class="w-full sm:w-1/4" [fullWidth]="true"
          [disabled]="!canPerformAction()" (buttonClick)="onReject()" />
        <app-button type="success" [text]="'common.actions.approve' | translate" icon="check" size="md"
          class="w-full sm:w-1/4" [fullWidth]="true"
          [disabled]="!canPerformAction()" (buttonClick)="onApprove()" />
      </div>
    </app-card>
    } @else {
    <div class="bg-(--color-bg-secondary) rounded-lg p-4 animate-pulse">
      <div class="flex items-center gap-4 mb-4">
        <div class="h-6 w-48 bg-(--color-bg-primary) rounded"></div>
        <div class="h-6 w-24 bg-(--color-bg-primary) rounded"></div>
      </div>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
        @for (i of [1,2,3,4]; track i) { <div class="h-20 bg-(--color-bg-primary) rounded"></div>
        }
      </div>
    </div>
    }
  </div>

  <mat-tab-group [(selectedIndex)]="activeSection" animationDuration="200ms">

    <mat-tab [label]="'tickets.detail.expediente' | translate">
      <app-applicant-record [ticketId]="ticketInformationId() ?? 0" [validationTicketId]="ticketValidationId() ?? 0"
        [locationDetail]="locationDetail()"
        [loading]="isLoading()" [isActionLoading]="isActionLoading()"
        [canPerformAction]="canPerformAction()" />
    </mat-tab>
    <mat-tab [label]="'tickets.detail.cuestionario' | translate">
      <app-questionnaire [ticketId]="ticketInformationId() ?? 0"
        [loading]="isLoading()" />
    </mat-tab>
    <mat-tab [label]="'tickets.detail.score' | translate">
      <app-score [ticketId]="ticketInformationId() ?? 0" [loading]="isLoading()" [coordinates]="coordinates()" [locationDetail]="locationDetail()" />
    </mat-tab>
  </mat-tab-group>
</div>